import { formatTimeWithSeconds } from 'Domain/schedule-ruleset/helper/formatTimeWithSeconds';
import { transformAccountLivestreamIds } from 'Domain/schedule-ruleset/helper/transformAccountLivestreamIds';
import { transformUserIds } from 'Domain/schedule-ruleset/helper/transformUserIds';

const upsertScheduleRulesetPayload = (formField) => {
  const payload = {
    type: formField?.type?.value,
    brandName: formField?.brand?.value,
    liveHours: parseInt(formField?.normalLiveHours?.value),
    paydayLiveHours: parseInt(formField?.paydayLiveHours?.value),
    isUseAgency: formField?.isUseAgency,
    normalStart: formatTimeWithSeconds(formField?.normalStart?.value),
    normalEnd: formatTimeWithSeconds(formField?.normalEnd),
    paydayStart: formatTimeWithSeconds(formField?.paydayStart?.value),
    paydayEnd: formatTimeWithSeconds(formField?.paydayEnd),
  };

  if (formField?.isUseAgency) {
    payload.agencyNormalStart = formatTimeWithSeconds(formField?.agencyNormalStart?.value);
    payload.agencyNormalEnd = formatTimeWithSeconds(formField?.agencyNormalEnd?.value);
    payload.agencyPaydayStart = formatTimeWithSeconds(formField?.agencyPaydayStart?.value);
    payload.agencyPaydayEnd = formatTimeWithSeconds(formField?.agencyPaydayEnd?.value);
  } else {
    payload.agencyNormalStart = null;
    payload.agencyNormalEnd = null;
    payload.agencyPaydayStart = null;
    payload.agencyPaydayEnd = null;
  }

  payload.accountLivestreamIds = transformAccountLivestreamIds(formField);
  payload.userIds = transformUserIds(formField?.selectedHost);

  return payload;
};

export default upsertScheduleRulesetPayload;
